// WCAG 2.1 contrast ratio utility
function hexToRgb(hex) {
  if (!hex) return null;
  const h = hex.replace("#", "").trim();
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  if (full.length !== 6) return null;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some((v) => Number.isNaN(v))) return null;
  return { r, g, b };
}

function relativeLuminance({ r, g, b }) {
  const ch = [r, g, b].map((v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2];
}

export function contrastRatio(hexA, hexB) {
  const a = hexToRgb(hexA);
  const b = hexToRgb(hexB);
  if (!a || !b) return null;
  const la = relativeLuminance(a);
  const lb = relativeLuminance(b);
  const [hi, lo] = la > lb ? [la, lb] : [lb, la];
  return (hi + 0.05) / (lo + 0.05);
}

/** Returns 'fail' | 'aa-large' | 'aa' | 'aaa' */
export function contrastGrade(ratio) {
  if (ratio == null) return "unknown";
  if (ratio >= 7) return "aaa";
  if (ratio >= 4.5) return "aa";
  if (ratio >= 3) return "aa-large";
  return "fail";
}

/** Returns the best text color (#FFFFFF or #0F172A) for a given background. */
export function bestTextOn(bgHex) {
  const rgb = hexToRgb(bgHex);
  if (!rgb) return "#0F172A";
  const lum = relativeLuminance(rgb);
  // Threshold ~0.5 is the conventional cutoff
  return lum > 0.5 ? "#0F172A" : "#FFFFFF";
}
